import { Anchor, Container, Group, Stack, Text, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { AgentRolesList } from "../features/agentRoles/AgentRolesList";

// Страница «Роли агентов».
//
// Список 5 встроенных ролей с пометкой override'а и редактором промпта
// (default / custom) + историей версий. Глобального меню в проекте нет —
// навигация ссылками; ссылка обратно на очередь рядом с заголовком.
export function AgentRolesPage(): ReactElement {
  const { t } = useTranslation();

  return (
    <Container py="xl">
      <Stack gap="md">
        <Group justify="space-between">
          <Title order={1}>{t("agentRoles.title")}</Title>
          <Anchor component={Link} to="/queue">
            {t("agentRoles.backToQueue")}
          </Anchor>
        </Group>

        <Text c="dimmed">{t("agentRoles.subtitle")}</Text>

        <AgentRolesList />
      </Stack>
    </Container>
  );
}
